import * as React from "react";

import { IconHierarchy } from "../icons/IconHierarchy";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonHierarchy: React.FC<MprcIconButtonProps> = ({ title, children, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonHierarchy.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconHierarchy fixedWidth />
            { }
        </MprcIconButton>
    );
};
